import type { HomePageData } from '@/data/types';
import homeData from '@/data/home.json';

export function useHomeData() {
  const data = homeData as HomePageData;
  return { homeData: data, loading: false, error: null };
}